import PromisePool from 'es6-promise-pool';

import axios from '../axios';

// type Props = {
//   data: Array<any>,
//   maxParallelRequests?: number,
//   apiPath: string,
//   onlyParam?: boolean,
//   fieldName?: string,
//   callbackSuccess: (event: any) => void,
//   callbackError: (event: any) => void,
// }

export const poolHelper = async (params) => {
  const {data, apiPath, maxParallelRequests = 2, method = 'GET', callbackError, callbackSuccess} = params;
  let count = -1;
  const total = data.length - 1;
  
  const promiseProducer = function () {
    if (count < total) {
      count++;
      const path = apiPath(data[count]);
      if(method === 'POST') {
        return axios.post(path, data[count])
      }
      if(method === 'PUT') {
        return axios.put(path, data[count])
      }
      return axios.get(path)
    } else {
      return null;
    }
  };
  
  const pool = new PromisePool(promiseProducer, maxParallelRequests);

  pool.addEventListener('fulfilled', callbackSuccess);

  pool.addEventListener('rejected', callbackError);
  
  return pool.start();
};